<script>
	import { draw, fade } from "svelte/transition";
	import { cubicInOut } from "svelte/easing";
	import { dataUSEuropeArcs } from "../../../data";

	export let projection;
	export let color = "#ff8000";

	const transitionParameters = {
		duration: 2000,
		easing: cubicInOut,
	};

	let link;
	$: {
		link = ({ source, target }) => {
			const projectedSource = projection(source);
			const projectedTarget = projection(target);
			const dx = projectedTarget[0] - projectedSource[0],
				dy = projectedTarget[1] - projectedSource[1],
				dr = 10000;
			// dr = Math.sqrt(dx * dx + dy * dy) - ;

			if (projectedSource.some(Number.isNaN) || projectedTarget.some(Number.isNaN)) return null;
			else
				return (
					"M" +
					projectedSource[0] +
					"," +
					projectedSource[1] +
					"A" +
					dr +
					"," +
					dr +
					" 0 0,1 " +
					projectedTarget[0] +
					"," +
					projectedTarget[1]
				);
		};
	}
</script>

<g class="arcs">
	{#each dataUSEuropeArcs as arc (arc.id)}
		{@const d = link(arc)}
		{#if d}
			<path in:draw={transitionParameters} out:fade stroke="{color}80" fill="none" stroke-width={6} {d} />
		{/if}
	{/each}
</g>

<style>
	path {
		stroke-linecap: round;
	}
</style>
